import request from '@/utils/request'
import APIS from '@/permissions/index'

export function queryUsers (params) {
  return request({
    ...APIS['@userManage/Query_Users'],
    params
  })
}

export function queryPermissions (params) {
  return request({
    ...APIS['@userManage/Query_Permissions'],
    params
  })
}

export function updateUser (data) {
  return request({
    ...APIS['@userManage/Update_User'],
    data
  })
}

export function addUser (data) {
  return request({
    ...APIS['@userManage/Add_User'],
    data
  })
}

export function deleteUser (data) {
  return request({
    ...APIS['@userManage/Delete_User'],
    data
  })
}

export function exportUsers (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@userManage/Export_Users'],
    params,
    headers,
    responseType
  })
}
